module.exports = __webpack_public_path__ + "img/p8.036c24aa.png";